import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import Navigation from "@/components/Dashboard/Navigation";
import PageWrapper from "@/components/ui/PageWrapper";
import useHasMultientityDashboard from "@/hooks/useHasMultientityDashboard";

function Dashboard() {
  const { t } = useTranslation("common");
  const hasMultientityDashboard = useHasMultientityDashboard();

  return (
    <PageWrapper>
      <div className="mx-xl my-lg">
        <Typography step="3" as="h1" weight="bold" className="mb-sm">
          {t("common:welcome")}
        </Typography>
        {hasMultientityDashboard ? <Navigation /> : null}
        <Outlet />
      </div>
    </PageWrapper>
  );
}

export default Dashboard;
